<template>
  <div class="fullscreen-image">
    <img src="./assets/image.jpg" alt="Image">
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 设置 body 和 html 的高度为 100% */
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

/* 设置容器为全屏 */
.fullscreen-image {
  height: 100vh;
  width: auto;
}

/* 设置图片样式，使其铺满整个屏幕 */
.fullscreen-image img {
  width: 100%;
  height: auto;
}
</style>
